// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1uNfa","paramInput":"JobSimulator_paramInput__3qcj_","input":"JobSimulator_input__2gzKM"};